<template>
    <InfoModal v-model:open="open" :title="t('journeys.priorityGoalsInfoModal.title')" :sections="sections" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import InfoModal, { type InfoModalSection } from "./InfoModal.vue";

const open = defineModel<boolean>("open", { default: false });

const { t } = useI18n();

// Locale catalogue can finish loading after mount, so section copy must stay reactive to the active locale.
const sections = computed<InfoModalSection[]>(() => [
    {
        icon: "bi-chat-dots",
        title: t("journeys.priorityGoalsInfoModal.sections.coaching.title"),
        description: t("journeys.priorityGoalsInfoModal.sections.coaching.description"),
    },
    {
        icon: "bi-bullseye",
        title: t("journeys.priorityGoalsInfoModal.sections.suggestions.title"),
        description: t("journeys.priorityGoalsInfoModal.sections.suggestions.description"),
    },
    {
        icon: "bi-lightbulb",
        title: t("journeys.priorityGoalsInfoModal.sections.insights.title"),
        description: t("journeys.priorityGoalsInfoModal.sections.insights.description"),
    },
]);
</script>
